const Spinner = {
  baseStyle: {
    color: 'colors.brand2',
  },
}

export default Spinner
